import axios from "axios";
import { getToken } from "../storage/AuthStorage";

const createApiClient = (baseURL) => {
  const apiClient = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  apiClient.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  return apiClient;
};

const accountApi = createApiClient(process.env.REACT_APP_ACCOUNT_BASE_URL);
const clearingApi = createApiClient(process.env.REACT_APP_CLEARING_BASE_URL);
const pricingApi = createApiClient(process.env.REACT_APP_PRICING_BASE_URL);
const directPaymentApi = createApiClient(process.env.REACT_APP_DIRECT_PAYMENT_BASE_URL);
const paymentApi = createApiClient(process.env.REACT_APP_PAYMENT_BASE_URL);
const stationOpsApi = createApiClient(process.env.REACT_APP_STATION_OPS_BASE_URL);
const notificationApi = createApiClient(process.env.REACT_APP_NOTIFICATION_BASE_URL);

const marketingWebsiteApi = axios.create({
  baseURL: process.env.REACT_APP_MARKETING_WEBSITE_BASE_URL ?? "https://cocharge.de",
  headers: {
    "Content-Type": "application/json",
  },
});

marketingWebsiteApi.interceptors.request.use(
  (config) => {
    const token = process.env.REACT_APP_MARKETING_WEBSITE_TOKEN;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export {
  createApiClient,
  accountApi,
  clearingApi,
  pricingApi,
  directPaymentApi,
  paymentApi,
  stationOpsApi,
  notificationApi,
  marketingWebsiteApi,
};
